import { ISetSubscriptionsFormatParams } from '../types/actionParams';
import { IEmptyResult } from '../../../httpClient/serverApi/types/IResponse';
import { Request } from '../../../httpClient/serverApi/requests/Request';

export class SetSubscriptionsFormatRequest extends Request<ISetSubscriptionsFormatParams, IEmptyResult> {
  constructor(params: ISetSubscriptionsFormatParams) {
    super('setSubscriptionsFormat', params);
  }
}
